import React, { Component } from 'react';
import { View, NativeModules } from 'react-native';

import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { VFButton, VFText, TimelineEvents, Icon } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../FrameworkTestKeys';

import styles from './SecondPermissionsSteps.Styles';

const OpenDataUsageAccess = NativeModules.OpenDataUsageAccess;

class SecondPermissionStep extends Component {
  componentDidMount() {
    TimelineEvents.subscribe(this.setToBiProps);
  }

  onOpenUsageDataPress = () => {
    OpenDataUsageAccess.openDataUsageAccess(success => {
      if (success) {
        this.props.onNextStep();
      }
    });
  };
  setToBiProps = value => {
    const { isActive, initToBi, setToBiSize, withToBi, setToBiX, setToBiY } = this.props;

    if (isActive && withToBi) {
      if (_isFunction(initToBi)) {
        initToBi(50, value, 140);
      }

      if (_isFunction(setToBiSize)) {
        setToBiSize(140);
      }
      if (_isFunction(setToBiX)) {
        setToBiX(50);
      }
      if (_isFunction(setToBiY)) {
        setToBiY(value + 50);
      }
    }
  };
  render() {
    const { image, stepsImages, withToBi, theme } = this.props;
    const stepImage = stepsImages[image] || '';
    return (
      <View style={styles.container} testID={FrameworkTestKeys.secondPermissionStepContainerView}>
        <View
          style={styles.descriptionContaienr}
          testID={FrameworkTestKeys.secondPermissionStepDescriptionView}
        >
          <View
            style={styles.textContainer}
            testID={FrameworkTestKeys.secondPermissionStepDescriptionTextView}
          >
            <VFText
              style={styles.text}
              i18nKey={this.props.description}
              testKey={FrameworkTestKeys.SecondPermissionStepDescription}
            />
          </View>
          {!withToBi && (
            <Icon
              type={'image'}
              source={stepImage}
              style={styles.stepImage}
              testID={FrameworkTestKeys.secondPermissionStepDescriptionIcon}
            />
          )}
        </View>
        <View
          style={styles.buttonContainerStyle}
          testID={FrameworkTestKeys.secondPermissionStepButtonContainer}
        >
          <VFButton
            title={this.props.actionTitle1}
            textStyle={styles.textbutton1}
            onPress={this.onOpenUsageDataPress}
            type="primary"
            testKey={FrameworkTestKeys.OBAndroidSettings}
          />
          <VFButton
            title={this.props.actionTitle2}
            style={styles.skippedbtn(theme)}
            textStyle={styles.textbutton2(theme)}
            onPress={this.props.onSkipStep}
            type="secondary"
            testKey={FrameworkTestKeys.OBNotNowButton}
          />
        </View>
      </View>
    );
  }
}
SecondPermissionStep.defaultProps = {
  theme: LightThemeColors,
};

SecondPermissionStep.propTypes = {
  onNextStep: PropTypes.func,
  description: PropTypes.string,
  actionTitle1: PropTypes.string,
  actionTitle2: PropTypes.string,
  onSkipStep: PropTypes.func,
  isActive: PropTypes.bool,
  initToBi: PropTypes.func,
  setToBiSize: PropTypes.func,
  withToBi: PropTypes.bool,
  setToBiX: PropTypes.func,
  setToBiY: PropTypes.func,
  stepsImages: PropTypes.object,
  image: PropTypes.element,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export default withTheme(SecondPermissionStep);
